<main>
  <section class="section-bg layout-pt-lg layout-pb-lg">
    <div class="section-bg__item col-12">
      <img src="assets/pusula/banner2.png" alt="image">
      
    </div>

    <div class="container">
      <div class="row justify-center text-center">
        <div class="col-xl-6 col-lg-8 col-md-10">
          <h1 class="text-40 md:text-25 fw-600 text-white">Pusula Tatil'e Hoş Geldiniz</h1>
          <div class="text-white mt-15">Pusula Tatil'in güvenilir tatil rezervasyon platformu</div>
        </div>
      </div>
    </div>
  </section>

  <section class="layout-pt-lg layout-pb-md">
    <div data-anim-wrap class="container">
      <div data-anim-child="slide-up delay-1" class="row justify-center text-center">
        <div class="col-auto">
          <div class="sectionTitle -md">
            <h2 class="sectionTitle__title">Neden Pusula Tatil?</h2>
            <p class=" sectionTitle__text mt-5 sm:mt-0">Pusula Tatil, en iyi fiyat garantisini sunarak müşterilerimize
              en iyi hizmeti sağlamayı hedefler.</p>
          </div>
        </div>
      </div>

      <div class="row y-gap-40 justify-between pt-50">

        <div data-anim-child="slide-up delay-2" class="col-lg-3 col-sm-6">

          <div class="featureIcon -type-1 ">
            <div class="d-flex justify-center">
              <img src="assets/img/featureIcons/1/1.svg" alt="En İyi Fiyat Garantisi">
            </div>

            <div class="text-center mt-30">
              <h4 class="text-18 fw-500">En İyi Fiyat Garantisi</h4>
              <p class="text-15 mt-10">En uygun fiyatlarla hayalinizdeki tatili yaşayın.</p>
            </div>
          </div>

        </div>

        <div data-anim-child="slide-up delay-3" class="col-lg-3 col-sm-6">

          <div class="featureIcon -type-1 ">
            <div class="d-flex justify-center">
              <img src="assets/img/featureIcons/1/2.svg" alt="Kolay ve Hızlı Rezervasyon">
            </div>

            <div class="text-center mt-30">
              <h4 class="text-18 fw-500">Kolay ve Hızlı Rezervasyon</h4>
              <p class="text-15 mt-10">Birkaç adımda rezervasyonunuzu tamamlayın.</p>
            </div>
          </div>

        </div>

        <div data-anim-child="slide-up delay-4" class="col-lg-3 col-sm-6">

          <div class="featureIcon -type-1 ">
            <div class="d-flex justify-center">
              <img src="assets/img/featureIcons/1/3.svg" alt="7/24 Müşteri Hizmetleri">
            </div>

            <div class="text-center mt-30">
              <h4 class="text-18 fw-500">7/24 Müşteri Hizmetleri</h4>
              <p class="text-15 mt-10">Her an yanınızdayız, sorularınız için bize ulaşın.</p>
            </div>
          </div>

        </div>

      </div>
    </div>
  </section>

  <section class="layout-pt-md">
    <div class="container">
      <div class="row y-gap-30 justify-between items-center">
        <div class="col-lg-5">
          <h2 class="text-30 fw-600">Pusula Tatil Hakkında</h2>
          <p class="mt-5">Pusula Tatil, en iyi fiyat garantisini sunarak müşterilerimize en iyi hizmeti sağlamayı
            hedefler.</p>

          <p class="text-dark-1 mt-60 lg:mt-40 md:mt-20">
            Pusula Tatil, en iyi fiyat garantisini sunarak müşterilerimize en iyi hizmeti sağlamayı hedefler.
          </p>
        </div>

        <div class="col-lg-6">
          <img src="assets/pusula/about.png" alt="image" class="rounded-4">
      
        </div>
      </div>
    </div>
  </section>

  <section class="pt-60">
    <div class="container">
      <div class="border-bottom-light pb-40">
        <div class="row y-gap-30 justify-center text-center">

          <div class="col-xl-3 col-6">
            <div class="text-40 lg:text-30 lh-13 fw-600">+50</div>
            <div class="text-14 lh-14 text-light-1 mt-5">Ekibimiz</div>
          </div>

          <div class="col-xl-3 col-6">
            <div class="text-40 lg:text-30 lh-13 fw-600">10.000+</div>
            <div class="text-14 lh-14 text-light-1 mt-5">Toplam Hizmet Sayısı</div>
          </div>

          <div class="col-xl-3 col-6">
            <div class="text-40 lg:text-30 lh-13 fw-600">2M</div>
            <div class="text-14 lh-14 text-light-1 mt-5">Mutlu Müşteri Sayısı</div>
          </div>

          <div class="col-xl-3 col-6">
            <div class="text-40 lg:text-30 lh-13 fw-600">574,974</div>
            <div class="text-14 lh-14 text-light-1 mt-5">Gönüllü Sayısı</div>
          </div>

        </div>
      </div>
    </div>
  </section>


  <app-newsletter></app-newsletter>
</main>